import { httpClient } from "@services/api/httpClient";

interface GetOfferApplicantParams {
  id: number
}

export async function getByOfferApplicantBuilderId({id }: GetOfferApplicantParams) {
  const response = await httpClient.get("/offer-applicant/get-by-offer-applicant-builder-id", {
    params: { id }
  });
  return response.data;
}